import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
   name: 'phone',
   standalone: false,
})
export class PhonePipe implements PipeTransform {
   transform(phoneValue: number | string, country: string): any {
      try {
         const phoneString = phoneValue.toString()
         let formattedPhone = ''

         if (phoneString.length !== 10) {
            return phoneValue
         }

         if (country === 'US') {
            formattedPhone = `(${phoneString.slice(0, 3)}) ${phoneString.slice(3, 6)}-${phoneString.slice(6)}`
         } else {
            formattedPhone = phoneString
         }

         return formattedPhone
      } catch (error) {
         return phoneValue
      }
   }
}
